import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCgXHQJv5l7T7vBK-wrFHqZWtQAnwJ8HHM",
  authDomain: "bondhu-78e11.firebaseapp.com",
  projectId: "bondhu-78e11",
  storageBucket: "bondhu-78e11.firebasestorage.app",
  messagingSenderId: "743470888874",
  appId: "1:743470888874:web:3048e3918fc1975762ddd3"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
